// extracted by mini-css-extract-plugin
export default {"price":"L7-z","onSale":"M7-z","msrpLabelPrice":"N7-z","msrpLabel":"O7-z","originalPrice":"P7-z","percentOff":"Q7-z"};